import { Id } from './convex/_generated/dataModel'

export type Currency = 'USD' | 'EUR' | 'JPY' | 'GBP' | 'CHF' | 'CAD' | 'AUD' | 'NZD' | 'INR'
export type Status = 'ACTIVE' | 'INACTIVE'
export type Palette = 'COLOR_1' | 'COLOR_2' | 'COLOR_3' | 'COLOR_4' | 'COLOR_5'
export type RateType = 'HOURLY' | 'WEEKLY' | 'MONTHLY' | 'YEARLY'
export type PricingType = 'FIXED' | 'HOURLY'
export type PaymentInterval = 'WEEKLY' | 'Bi-WEEKLY' | 'MONTHLY'
export type BillableType = 'PERCENTAGE' | 'FIXED PRICE'
export type PaymentMode = 'STRIPE'
export type Industries = 'Internet and Technology' | 'Agriculture' | 'Construction'
export type Terms = 'Net0' | 'Net1'

export interface Client {
  _id?: Id
  name: string
  contactName: string
  contactEmail: string
  contactPhone: string
  companyLocation: string
  companyIndustry: Industries
  terms: Terms
  preferredCurrency: Currency
  defaultBillableRate?: number
  status: Status
}

export interface Project {
  _id?: Id
  name: string
  status: Status
  color: Palette
  startDate: string
  endDate: string
  client: Id
}

export interface ResourceSchema {
  _id?: Id
  name: string
  email: string
  designation: string
  location: string
  currency: Currency
  rateType: RateType
  rate: number
  proposedBillableType: BillableType
  proposedBillableValue: number
}
export interface Resource extends Omit<ResourceSchema, '_id'> {
  _id: Id
}

export interface ResourceEstimate {
  resource?: Id
  pricingType?: PricingType
  actualCost?: number
  chargePrice?: number
  hours?: number
}
export interface Estimate {
  _id?: Id
  name?: string
  buffer?: number
  resources?: Array<ResourceEstimate>
  proposalId: Id
}

export interface ProposalSchema {
  _id?: Id
  name: string
  project: Id
}

export interface ProposalSchemaWithId extends Omit<ProposalSchema, '_id'> {
  _id: Id
}

export interface Proposal {
  _id: Id
  name: string
  project: Project
  estimates: Array<Estimate>
}

export interface ProposalResolved extends Omit<Proposal, 'project'> {
  project: Project
}

export const IndustriesList: Array<Industries> = ['Agriculture', 'Construction', 'Internet and Technology']
export const CurrencyList: Array<Currency> = ['AUD', 'CAD', 'CHF', 'EUR', 'GBP', 'INR', 'JPY', 'NZD', 'USD']
export const PaletteList: Array<Palette> = ['COLOR_1', 'COLOR_2', 'COLOR_3', 'COLOR_4', 'COLOR_5']
export const RateTypeList: Array<RateType> = ['HOURLY', 'MONTHLY', 'WEEKLY', 'YEARLY']
export const PaymentIntervalList: Array<PaymentInterval> = ['Bi-WEEKLY', 'MONTHLY', 'WEEKLY']
export const TermsList: Array<Terms> = ['Net0', 'Net1']

export const PRICING_TYPE_HOURLY: PricingType = 'HOURLY'
export const PRICING_TYPE_FIXED: PricingType = 'FIXED'
